<h2 class="mb-1" mat-dialog-title>{{'CONDITIONS_PARKINGSPACESIZE.TITLE' | transloco}}</h2>
<mat-dialog-content>
    <p>1. {{'CONDITIONS_PARKINGSPACESIZE.BODY1' | transloco}}</p>
    <p>2. {{'CONDITIONS_PARKINGSPACESIZE.BODY2' | transloco}}</p>
    <p>3. {{'CONDITIONS_PARKINGSPACESIZE.BODY3' | transloco}}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="" cdkFocusInitial>{{ 'FORM.TERMSDIALOGCLOSE' | transloco }}</button>
</mat-dialog-actions>